interface DetailCardProps {
  title: string;
  rows: [string, string | null | undefined][];
}

export function DetailCard({ title, rows }: DetailCardProps) {
  const shown = rows.filter(([, value]) => value !== null && value !== undefined && value !== '');
  if (shown.length === 0) return null;

  return (
    <dl className="min-w-0 flex-1 rounded-md border bg-muted/40 p-3 text-sm">
      <p className="mb-1 font-medium">{title}</p>
      {shown.map(([label, value]) => (
        <div key={label} className="flex gap-2">
          <dt className="shrink-0 text-muted-foreground">{label}:</dt>
          <dd className="min-w-0 break-words">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
